/**
 * URL WebSocket для ActionCable / AnyCable (как в packs/widget.jsx).
 */
export function getCableUrl() {
  if (process.env.NODE_ENV === 'development') {
    return 'ws://localhost:8080/cable';
  }
  const proto = window.location.protocol === 'https:' ? 'wss' : 'ws';
  return `${proto}://${window.location.host}/cable`;
}
